/**
 * API Configuration
 *
 * In development, we use relative URLs (Vite proxy handles them)
 * In production (Firebase), we use the Vercel API URL
 */

const isDevelopment = import.meta.env.DEV;

// Vercel API URL for production
export const VERCEL_API_URL = 'https://energycosmos.vercel.app';

// Use relative URLs in development, Vercel URL in production
export const API_BASE_URL = isDevelopment ? '' : VERCEL_API_URL;

export default {
  API_BASE_URL,
  VERCEL_API_URL,
  isDevelopment,
};
